<template lang="pug">
Modal(@close="onCancel", :top="top")
  span(slot="header") {{t('app.registration.medication.add')}}
  template(slot="content")
    template(v-if="clear_list")
      .row
        .select
            span.selected
              span.value {{object.name || t('app.registration.medication.add_new')}}
              span.caret
            select(v-model="object")
              option(:value="{}" v-if="entity_attrs.id<1") {{t('app.registration.medication.add_new')}}
              option(:value="entity", v-for="entity in clear_list") {{entity.name}}
      hr
    validation-observer(slim ref="medicalForm")
        .row(v-for="attr in attrs")
          .form-col.large-24
            Field(
              v-model="object[attr]"
              :attr="attr"
              noautosave="1"
              :disabled="!state.current_reg.person_id"
              :required="requiredAttrs.includes(attr)"
              @change="state.current_reg.doTouch()"
            )
        .row
          .form-col.large-24
            .buttons.reverse-button-order
              .left
                a.button.secondary(@click.prevent="onCancel") {{t('app.buttons.cancel')}}
              .right
                a.button(@click.prevent="onSave") {{ object.id ? t('app.buttons.edit') : t('app.buttons.add')}}
</template>
<script>
import helpers from "../../../code/base_mixins";
import Modal from "../../shared/_modal";
import Field from "../form_block/_field"
// You will get warning on object change but it's safe.
// We don't manipulate it. I just didn't want to create
// one more object to escape warning.
export default{
  components:{Modal,Field},
  mixins: [helpers],
  props: {
    entity_attrs: {type: Object, required: true, default: ()=>({})},
    attrs: {type: Array, required: true, default: ()=>({})},
    requiredAttrs: {type: Array, required: true, default: ()=>({})},
    usedEntityIds: {type: Array, required: false, default: ()=>([])},
    top: {type: Boolean, required: true},
  },
  emits: {
    save: {},
    cancel: {},
  },
  data(){
    return {
      list: [],
      object: {},
    }
  },
  computed: {
    clear_list(){
      return this.list.filter((entity)=>!this.usedEntityIds.includes(entity.id))
    }
  },
  created(){
    this.$store.dispatch("reg_store/people_medications").then((a)=>this.list=a)
    this.object = {...this.entity_attrs}
  },
  methods: {
    async onSave(){
      const valid = await this.$refs.medicalForm.validate()
      if (!valid) return;

      this.$emit('save', this.object)
    },
    onCancel(){
      this.$emit('cancel', this.object)
    }
  },
}
</script>